import {
  BusinessOverviewMetric,
  BuyerOfferAnalysisFragment,
} from '@client/graphql/__generated__/types';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { OfferScorecardsTable } from '../../OfferScorecard/OfferScorecardsTable';
import { BusinessOverviewOffersTable } from './BusinessOverviewOffers/BusinessOverviewOffersTable';
import { useOrganizationPipelineContext } from './OrganizationPipelineContext';

export const OrganizationPipelineTable = () => {
  const { offerScorecards, selectedTab, businessOverviewOffers, summary } =
    useOrganizationPipelineContext();

  const tables = {
    [BusinessOverviewMetric.OFFER_SCORECARDS]: (
      <OfferScorecardsTable
        fetchTriggerRef={offerScorecards?.fetchTriggerRef}
        loading={offerScorecards?.loading || false}
        offerScorecards={
          (offerScorecards?.data || []) as BuyerOfferAnalysisFragment[]
        }
      />
    ),
    [BusinessOverviewMetric.OFFERS_OUT]: (
      <BusinessOverviewOffersTable
        businessOverviewOffers={businessOverviewOffers?.data || []}
        fetchTriggerRef={businessOverviewOffers?.fetchTriggerRef}
        loading={businessOverviewOffers?.loading || false}
      />
    ),
    [BusinessOverviewMetric.OFFERS_ACCEPTED]: (
      <BusinessOverviewOffersTable
        businessOverviewOffers={businessOverviewOffers?.data || []}
        fetchTriggerRef={businessOverviewOffers?.fetchTriggerRef}
        loading={businessOverviewOffers?.loading || false}
      />
    ),
    [BusinessOverviewMetric.SIGNED_AGENCY_AGREEMENTS]: (
      <div>Signed Agency Agreements</div>
    ),
    [BusinessOverviewMetric.OFFERS_CLOSED]: <div>Offers Closed</div>,
  };

  if (!summary.data?.length) {
    return <CenterSpinner />;
  }

  return tables[selectedTab];
};
